import { ModeleDeBase } from "./ModeleDeBase";

export interface IVariableEnvironnementDefinitionCDS {
  environmentvariabledefinitionid: string;
  schemaname: string;
}

export class VariableEnvironnementDefinition extends ModeleDeBase {
  nomVariableEnv: string;

  constructor(entity: IVariableEnvironnementDefinitionCDS) {
    super(entity.environmentvariabledefinitionid);

    this.nomVariableEnv = entity.schemaname;
  }

  serialiser(): IVariableEnvironnementDefinitionCDS {
    return {
      environmentvariabledefinitionid: this.id,
      schemaname: this.nomVariableEnv,
    };
  }
}
